import { AORTA_GO_HOST } from "../constants/env";
import isMobileWeb from "./is-mobile-web";

const DOC_APP_WHITELISTED_HEADERS = [
  "flavour",
  "auth",
  "resjwttoken",
  "client-id",
  "version",
  "utm_medium",
  "utm_source",
  "utm_campaign",
];

export async function refreshToken() {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.set("client-id", "doc-web");
  const raw = JSON.stringify({});

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    credentials: "include",
    mode: "cors",
  };
  try {
    const response = await fetch(
      `${AORTA_GO_HOST}/emr/v3/auth/refresh`,
      requestOptions
    );
    if (response.status === 401) {
      return false;
    }
  } catch (error) {
    return false;
  }
  return true;
}

export default async function fetchWrapper(
  url: RequestInfo,
  options: RequestInit | undefined = {},
  retry: boolean = true
): Promise<Response> {
  try {
    const newHeaders = new Headers(options.headers);

    let clientId;
    let urlsNotToFireWhoAmI = [
      "/doctor-onboarding/cowin-login",
      "/doctor-onboarding/eka-login",
      "/doctor-onboarding",
    ];
    let currentPathname;

    if (!newHeaders.get("client-id")) {
      newHeaders.set("client-id", "doc-web");
    }

    if (!newHeaders.get("flavour")) {
      const isMobile = isMobileWeb();
      newHeaders.set("flavour", isMobile ? "mweb" : "dweb");
    }

    const response: Response = await fetch(url, {
      ...options,
      headers: newHeaders,
      credentials: "include",
    });
    if (!!window) {
      currentPathname = window.location.pathname;
      clientId = newHeaders.get("client-id");
    }
    if (response.status === 401 && retry) {
      const loginSuccess = await refreshToken();
      if (loginSuccess) {
        return await fetchWrapper(url, options, false);
      }
    }
    // if (response.status > 401) {
    //   sendApiFailedEvent({ url, params: { responseStatus: response.status } });
    // }
    return response;
  } catch (error: any) {
    // sendApiFailedEvent({ url, params: { error: `${error.message || error}` } });
    console.error(error);
    throw error;
  }
}

export async function updateRefreshToken() {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.set("client-id", "doc-web");
  const raw = JSON.stringify({});

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
    credentials: "include",
    mode: "cors",
  };
  try {
    const response = await fetch(
      `${AORTA_GO_HOST}/emr/v3/auth/refresh`,
      requestOptions
    );

    if (response.status === 200) {
      const resp = await response.json();
      return resp;
    }
    if (response.status === 401) {
      return false;
    }
  } catch (error) {
    return false;
  }
  return true;
}
